import React from 'react';
import InputField from './Components/InputField'
import TextAreaField from './Components/TextAreaField'
import OptionField from './Components/OptionField'
import CheckboxField from './Components/CheckboxField'
import DateField from './Components/DateField'
import SubmitButton from './Components/SubmitButton'


class UmbracoForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    const el = document.querySelector('#react-form-umbraco');
    const nodeId = el.dataset.node;
    const culture = el.dataset.culture || '';

    this.constants = {
      response: {
        LOADING: "LOADING",

      }
    }

    this.state = {
      formFields: [],
      submitButton: "",
      token: "",
      recaptchaEnabled: false,
      recaptchaSiteKey: "",
      isLoading: false,
      nodeId: nodeId,
      culture: culture,
      response: "",
      fieldErrors: {}
    };
  }

  loadRecaptchaScript(siteKey) {
    if (!siteKey || document.querySelector('script[data-recaptcha-script]')) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    script.dataset.recaptchaScript = 'true';
    document.body.appendChild(script);
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    const cultureParam = this.state.culture ? `&culture=${this.state.culture}` : '';
    const url = `/Umbraco/Api/ReactForm/GetFormStructure?currentPageId=${this.state.nodeId}${cultureParam}`;

    console.group('[ReactForm] GetFormStructure');
    console.log('nodeId:', this.state.nodeId);
    console.log('culture from data-culture:', this.state.culture || '(empty — not set on div)');
    console.log('fetch URL:', url);
    console.groupEnd();

    fetch(url)
      .then(response => response.json())
      .then(data => {
        console.group('[ReactForm] API response');
        console.log('debug:', data.debug);
        console.log('fields:', data.fields);
        console.groupEnd();
        this.setState({ formFields: data.fields, submitButton: data.submitText, token: data.token, recaptchaEnabled: data.recaptchaEnabled, recaptchaSiteKey: data.recaptchaSiteKey, isLoading: false });
        if (data.recaptchaEnabled) {
          this.loadRecaptchaScript(data.recaptchaSiteKey);
        }
      });
  }

  submitForm(arrayData, recaptchaToken) {
    const body = {
      nodeId: this.state.nodeId,
      token: this.state.token,
      data: JSON.stringify(arrayData),
      recaptchaToken: recaptchaToken
    }

    fetch('/Umbraco/Api/ReactForm/Submit', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(body)
    })
    .then(response => response.json())
    .then(response => {
      if (response.fieldErrors) {
        this.setState({ response: "", fieldErrors: response.fieldErrors });
      } else {
        this.setState({ response: response, fieldErrors: {} });
      }
    });
  }

  handleSubmit(event) {

    this.setState({ response: this.constants.response.LOADING, fieldErrors: {} });

    const formData = new FormData(event.target);
    event.preventDefault();

    const arrayData = [];
    for (let [key, value] of formData.entries()) {
      arrayData.push({ key, value });
    }

    if (!this.state.recaptchaEnabled) {
      this.submitForm(arrayData, null);
      return;
    }

    if (!window.grecaptcha || !this.state.recaptchaSiteKey) {
      this.setState({ response: { success: false, message: "Unable to verify request. Please refresh the page and try again." } });
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(this.state.recaptchaSiteKey, { action: 'submit' })
        .then(recaptchaToken => this.submitForm(arrayData, recaptchaToken))
        .catch(() => this.setState({ response: { success: false, message: "Unable to verify request. Please refresh the page and try again." } }));
    });
  }

  render() {
    const { formFields, submitButton, isLoading, response, fieldErrors } = this.state;
    const responseType = this.constants.response;

    if (response === "" || response === responseType.LOADING) {
      if (isLoading) {
        return (
          <p>Loading...</p>
        )
      }

      if (!isLoading && formFields.length > 0) {

        const submitDisabled = this.state.response === responseType.LOADING;
        return (
          <form onSubmit={this.handleSubmit} autoComplete="off">
            {formFields.map((field, index) => {
              if(field.type === "textarea"){
                return (<TextAreaField key={index} index={index} field={field} error={fieldErrors[field.name]} />)
              }
              if(field.type === "dropdown"){
                return (<OptionField key={index} index={index} field={field} />)
              }
              if(field.type === "checkbox"){
                return (<CheckboxField key={index} index={index} field={field} />)
              }
              if(field.type === "date"){
                return (<DateField key={index} index={index} field={field} />)
              }
              return (<InputField key={index} index={index} field={field} error={fieldErrors[field.name]} />)
            })}
            <SubmitButton text={submitButton} isDisabled={submitDisabled}></SubmitButton>
          </form>
        )
      }

      return (
        <p>No data to display. It doesn't look like fields have been created for this form.</p>
      )
    } 
    if(response.redirectUrl !== undefined && response.redirectUrl !== ""){      
      return window.location.href = response.redirectUrl;
    }
    return (
      <p>{response.message}</p>
      )
  }
}
export default UmbracoForm;